import React from 'react';

export const TelegramLogo = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 0.96875C35.2188 0.96875 45.2812 11.0312 45.2812 23.25C45.2812 35.5586 35.2188 45.5312 23 45.5312C10.6914 45.5312 0.71875 35.5586 0.71875 23.25C0.71875 11.0312 10.6914 0.96875 23 0.96875ZM33.2422 16.1523C33.332 15.8828 33.332 15.6133 33.2422 15.2539C33.2422 15.0742 33.0625 14.8047 32.9727 14.7148C32.7031 14.4453 32.2539 14.4453 32.0742 14.4453C31.2656 14.4453 29.918 14.8945 23.7188 17.5C21.5625 18.3984 17.25 20.1953 10.7812 23.0703C9.70312 23.5195 9.16406 23.8789 9.07422 24.3281C8.98438 25.0469 10.1523 25.3164 11.5 25.7656C12.668 26.125 14.1953 26.5742 15.0039 26.5742C15.7227 26.5742 16.5312 26.3047 17.4297 25.6758C23.4492 21.543 26.5938 19.4766 26.7734 19.4766C26.9531 19.4766 27.1328 19.3867 27.2227 19.4766C27.4023 19.6562 27.4023 19.8359 27.3125 19.9258C27.2227 20.375 21.5625 25.5859 21.2031 25.9453C19.9453 27.2031 18.5078 28.0117 20.7539 29.4492C22.6406 30.707 23.7188 31.5156 25.6953 32.7734C26.9531 33.582 27.9414 34.5703 29.1992 34.4805C29.8281 34.3906 30.457 33.8516 30.7266 32.1445C31.5352 28.2812 32.9727 19.6562 33.2422 16.1523Z"
        fill="#0088CC"
      />
    </svg>
  );
};
